export default __webpack_public_path__ + "static/media/logo.0f7f5397.png";